import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";

// Pages
import Dashboard from "../pages/Dashboard/Dashboard";
import LeadsNew from "../pages/Leads/LeadsNew";
import LeadsInProcess from "../pages/Leads/LeadsInProcess";
import LeadsHold from "../pages/Leads/LeadsHold";
import ApplicationsNew from "../pages/Applications/ApplicationsNew";
import ApplicationsInProcess from "../pages/Applications/ApplicationsInProcess";
import ApplicationsHold from "../pages/Applications/ApplicationsHold";
import ApplicationsRecommended from "../pages/Applications/ApplicationsRecommended";
import ApplicationsSentBack from "../pages/Applications/ApplicationsSentBack";
import ApplicationsSanctioned from "../pages/Sanctions/ApplicationsSanctioned";
import DisbursalNew from "../pages/Disbursal/DisbursalNew";
import DisbursalInProcess from "../pages/Disbursal/DisbursalInProcess";
import DisbursalSendBack from "../pages/Disbursal/DisbursalSendBack";
import DisbursalHold from "../pages/Disbursal/DisbursalHold";
import DisbursalPending from "../pages/Disbursal/DisbursalPending";
import Disbursed from "../pages/Disbursal/Disbursed";
import DisburseWaivedOff from "../pages/Disbursal/DisburseWaivedOff";
import RejectedApps from "../pages/RejectedApps/RejectedApps";
import VerificationStatus from "../pages/VerificationStatus/VerificationStatus";
import CustomerFeedback from "../pages/CustomerFeedback/CustomerFeedback";
import Export from "../pages/Export/Export";
import MISReport from "../pages/MISReport/MISReport";
import BlacklistUser from "../pages/BlacklistUser/BlacklistUser";

const AppRouter = () => {
  return (
    <Routes>
      {/* Dashboard Layout Routes */}
      <Route path="/" element={<DashboardLayout />}>
        {/* Default route - redirects to dashboard */}
        <Route index element={<Navigate to="/dashboard" replace />} />
        
        {/* Dashboard */}
        <Route path="dashboard" element={<Dashboard />} />
        
        {/* Leads Routes */}
        <Route path="leads">
          <Route path="new" element={<LeadsNew />} />
          <Route path="in-process" element={<LeadsInProcess />} />
          <Route path="hold" element={<LeadsHold />} />
        </Route>
        
        {/* Applications Routes */}
        <Route path="applications">
          <Route path="new" element={<ApplicationsNew />} />
          <Route path="in-process" element={<ApplicationsInProcess />} />
          <Route path="hold" element={<ApplicationsHold />} />
          <Route path="recommended" element={<ApplicationsRecommended />} />
          <Route path="sent-back" element={<ApplicationsSentBack />} />
        </Route>
        
        {/* Sanctioned Route - Separate from Applications */}
        <Route path="sanctioned" element={<ApplicationsSanctioned />} />
        
        {/* Rejected Apps Route */}
        <Route path="rejected-apps" element={<RejectedApps />} />
        
        {/* Verification Status Route */}
        <Route path="verification-status" element={<VerificationStatus />} />
        
        {/* Customer Feedback Route */}
        <Route path="customer-feedback" element={<CustomerFeedback />} />
        
        {/* Export Route */}
        <Route path="export" element={<Export />} />
        
        {/* MIS Report Route */}
        <Route path="mis-report" element={<MISReport />} />
        
        {/* Blacklist User Route */}
        <Route path="blacklist-user" element={<BlacklistUser />} />
        
        {/* Disbursal Routes */}
        <Route path="disbursal">
          <Route path="new" element={<DisbursalNew />} />
          <Route path="in-process" element={<DisbursalInProcess />} />
          <Route path="send-back" element={<DisbursalSendBack />} />
          <Route path="hold" element={<DisbursalHold />} />
          <Route path="pending" element={<DisbursalPending />} />
          <Route path="disbursed" element={<Disbursed />} />
          <Route path="waived-off" element={<DisburseWaivedOff />} />
        </Route>
        
        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;

